export default {
  ACTIONS: {
    NUM: 'NUM',
    SET_USERINFO: 'SET_USERINFO',
    GET_USERINFO: 'GET_USERINFO'
  },
  MUTATIONS: {
    SET_USERINFO: 'SET_USERINFO',
    GET_USERINFO: 'GET_USERINFO'
  }
};
